<div class="contactWrapper">
    <div class="flex flex-row gap-5 mobileCol">
        <mat-card class="w-100 h-fit">
            <mat-card-header>
                <mat-card-title class="mb-5">Contact Us</mat-card-title>
                @if (!community?.contact_us_text_rendered) {
                    <mat-card-subtitle class="mt-5">We would love to hear from you
                    </mat-card-subtitle>
                }
            </mat-card-header>
            <mat-card-content>
                @if (community?.contact_us_text_rendered) {
                    <div [innerHTML]="community.contact_us_text_rendered"
                         class="ck-editorControl"></div>
                }
                <form [formGroup]="contactForm" class="mt-15">
                    <mat-form-field appearance="outline" class="w-100" color="accent">
                        <mat-label>Message</mat-label>
                        <textarea formControlName="message" matInput rows="4"></textarea>
                        @if (contactForm.controls['message'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-checkbox formControlName="isAnonymous">Anonymous</mat-checkbox>
                </form>
            </mat-card-content>
            <mat-card-actions>
                <div class="d-flex flex-col text-center align-items-center w-100">
                    <button (click)="submit()" [disabled]="contactForm.invalid || loading || timer > 0"
                            color="accent" mat-flat-button>
                        Submit
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                    @if (timer > 0) {
                        <br>
                        <small>Please wait {{ timer }} seconds before submitting the form again</small>
                    }
                    @if (!isLoggedIn) {
                        <small class="conversationHint">Log in to view replies and keep the conversation going
                            here.</small>
                    }
                </div>
            </mat-card-actions>
        </mat-card>

        @if (isLoggedIn) {
            <mat-card class="threadCard">
                <mat-card-header>
                    <mat-card-title class="mb-5">Your Conversations</mat-card-title>
                    <mat-card-subtitle class="mt-5">Staff replies will appear here, and you can reply back in the same
                        thread.
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    @if (threadsLoading) {
                        <div class="w-100 d-flex justify-content-center">
                            <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
                        </div>
                    } @else if (!feedbackThreads.length) {
                        <div class="emptyThreads">No conversations yet.</div>
                    } @else {
                        <div class="threadCards">
                            @for (feedback of feedbackThreads; track feedback.id) {
                                <div class="contactThread">
                                    <div class="threadHeader">
                                        <div>
                                            <div class="threadTitle">
                                                @if (feedback.community?.company_name) {
                                                    {{ feedback.community.company_name }}
                                                } @else {
                                                    Conversation #{{ feedback.id }}
                                                }
                                            </div>
                                            <div class="threadSubtitle">
                                                Started {{ feedback.created_at | relativeTime }} · Last
                                                activity {{ lastActivity(feedback) | relativeTime }}
                                            </div>
                                        </div>
                                        <div class="threadBadges">
                                            @if (feedback.is_anonymous) {
                                                <div class="threadBadge">Sent anonymously</div>
                                            }
                                            @if (hasStaffReply(feedback)) {
                                                <div class="threadBadge threadBadge--success">Staff replied</div>
                                            }
                                        </div>
                                    </div>

                                    <div class="threadList">
                                        @for (message of thread(feedback); track message.id) {
                                            <div [ngClass]="{'threadMessage': true, 'threadMessage--staff': message.is_from_staff}">
                                                <div class="threadMeta">
                                                    <span class="threadAuthor">{{ authorLabel(message) }}</span>
                                                    <span>{{ message.created_at | relativeTime }}</span>
                                                </div>
                                                <div class="threadBody">{{ message.body }}</div>
                                            </div>
                                        }
                                    </div>

                                    <div class="replyComposer">
                                        @if (feedback.responding) {
                                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                                <mat-label>Reply</mat-label>
                                                <textarea [(ngModel)]="feedback.replyDraft" matInput
                                                          rows="4"></textarea>
                                            </mat-form-field>
                                            <div class="replyActions">
                                                <button (click)="toggleReply(feedback)"
                                                        [disabled]="feedback.sendingReply" mat-stroked-button>
                                                    Cancel
                                                </button>
                                                <button (click)="respond(feedback)"
                                                        [disabled]="!canSendReply(feedback)"
                                                        color="primary"
                                                        mat-raised-button>
                                                    {{ feedback.sendingReply ? 'Sending...' : 'Send reply' }}
                                                </button>
                                            </div>
                                        } @else {
                                            <button (click)="toggleReply(feedback)" color="primary" mat-raised-button>
                                                Reply to thread
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </mat-card-content>
            </mat-card>
        }
    </div>
</div>
